import DomainEntity from '@/models/DomainEntity'

export default class StateContracts extends DomainEntity {
  static get collectionName() {
    return 'statecontracts/'
  }

  static get parentKey() {
    return 'state'
  }

  static defaults() {
    return {
      items: {},
    }
  }
}
